import { useContext, useMemo, useState } from "react";
import CouponServices from "../services/couponServices";
import { AuthContext } from "../contexts/AuthContext";

function useCoupon() {
  const { api } = useContext(AuthContext);

  const service = useMemo(() => new CouponServices(api), [api]);

  const normalizeList = (res) => {
    const data = res?.data?.data ?? res?.data ?? [];
    return Array.isArray(data) ? data : [];
  };

  const fetchCoupons = async () => {
    const res = await service.getAll();
    return res;
  };

  const createCoupon = async (data) => {
    const res = await service.create(data);
    await fetchCoupons();
    return res;
  };

  const updateCoupon = async (id, data) => {
    const res = await service.update(id, data);
    await fetchCoupons();
    return res;
  };

  const deleteCoupon = async (id) => {
    const res = await service.delete(id);
    await fetchCoupons();
    return res;
  };

  const verifierCoupon = async (data) => {
    const res = await service.verifier(data);
    return res;
  }

  const getCouponAutoApply = async (params) => {
    const res = await service.autoApply(params);
    return res;
  }

  return {
    fetchCoupons,
    createCoupon,
    updateCoupon,
    deleteCoupon,
    verifierCoupon,
    getCouponAutoApply
  };
}

export default useCoupon;
